import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle'
import ButtonCustom from '../../../component/button/buttonCustom'
import { Typography } from '@mui/material'
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { icons } from '../../../constants/images';
import { swalError, swalSuccess } from '../../../component/notification/swal';
import CMSApi from '../../../api/cms/cms.api';
import Logo from './logo';
import Background from './background';

export default function Customize() {
  const [fileLogo, setFileLogo] = useState<any>();
  const [fileBG, setFileBG] = useState<any>();
  const [editLogo, setEditLogo] = useState<boolean>(false)
  const [editBG, setEditBGo] = useState<boolean>(false)
  const [url, setUrl] = useState<string>('')
    useEffect(() => {
        const init = async () => {
          const response = await fetch("/resources/config.json");
          const results = await response.json();
          setUrl(results.REACT_APP_BASE_API);
        }
        init()
      }, [])
  // useEffect(() => {
  //   setFile(acceptedFiles.length > 0 ? URL.createObjectURL(acceptedFiles[0]) : '');

  // }, [acceptedFiles])

  const updateFile = async () => {
    if (fileLogo) {
      const formData = new FormData();
      formData.append("file", fileLogo)
      await CMSApi.patchAppLogo(formData).then(async (res) => {
        if (res?.data?.success) {
          setEditLogo(false)
        } else {

          swalError(res.data.description || res.data.message);
        }

      }).catch((error: any) => {
        swalError(error.response.data.description || error.response.data.message);
      })
    }
    if (fileBG) {
      const formData = new FormData();
      formData.append("file", fileBG)
      await CMSApi.patchLoginBackground(formData).then(async (res) => {
        if (res?.data?.success) {
          setEditBGo(false)
        } else {

          swalError(res.data.description || res.data.message);
        }

      }).catch((error: any) => {
        swalError(error.response.data.description || error.response.data.message);
      })
    }
    swalSuccess("อัพเดทไฟล์สำเร็จ")

  }
  return (
    <LayoutView>
      <LayoutTitle>
        <TitleText>ปรับแต่ง</TitleText>
        {fileBG || fileLogo ? <ButtonCustom variant={'outlined'}
          textButton={'บันทึก'}
          onClick={() => { updateFile() }}
          btnStyle={{
            '&.MuiButton-outlined': {
              color: `#fff !important`,
              border: `2px solid #026735 !important`,
              borderRadius: "10px !important",
              backgroundColor: '#026735 !important',
              '&:hover': {
                color: `#fff  !important`,
                border: `2px solid #026735 !important`,
                backgroundColor: '#026735 !important'
              },
            },
          }} /> : <></>}
      </LayoutTitle>
      <Logo baseUrl={url} file={fileLogo} setFile={setFileLogo} edit={editLogo} setEdit={setEditLogo} />
      <Background baseUrl={url} file={fileBG} setFile={setFileBG}edit={editBG} setEdit={setEditBGo}  />
      {/* <div>
        <Typography>พื้นหลัง</Typography>
        <div style={{
          borderRadius: '10px',
          border: '1px dashed #C1C3C7',
          padding: '12px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '189px'
        }} {...getRootProps({ className: 'dropzone' })}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
            <icons.uploadCloud />
            <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '12px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '12px' }}>Word, Excel, PDF, JPG or GIF ขนาดไม่เกิน 10MB</Typography>
            <ButtonCustom variant={'outlined'}
              // endIcon={<icons.downloadButton />}
              textButton={'เลือกไฟล์'}
              onClick={open}
              btnStyle={{
                '&.MuiButton-outlined': {
                  color: `#0A77FF !important`,
                  border: `1px dashed #0A77FF !important`,
                  backgroundColor: '#fff !important',
                  borderRadius: "10px !important",
                  '&:hover': {
                    color: `#0A77FF  !important`,
                    border: `1px dashed #0A77FF !important`,
                    backgroundColor: '#fff !important'
                  },
                },
              }} />
          </div>
          <input {...getInputProps()} />

        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonCustom variant={'outlined'}
            startIcon={<icons.iconUpload />}
            textButton={'แก้ไข'}
            onClick={() => { }}
            style={{ marginRight: '4px' }}
            btnStyle={{
              '&.MuiButton-outlined': {
                color: `#EEA23E !important`,
                border: `2px solid #EEA23E !important`,
                borderRadius: "10px !important",
                '&:hover': {
                  color: `#EEA23E  !important`,
                  border: `2px solid #EEA23E !important`,
                  backgroundColor: '#FFFAF2 !important'
                },
              },
            }} />
        </div>
      </div> */}
    </LayoutView>
  )
}
